import React from 'react';

function UserMessage(props) {
    const { content, userAvatar } = props && props;
    return (
        <div className={`messengerCt__wrapper`}>
            <div className="messengerCt__message messengerCt__message--out">
                <div className="messengerCt__message-body">
                    <div className="messengerCt__message-content --arrow-right">
                        <div className="messengerCt__message-text">
                            <div className="whiteSpace-break" dangerouslySetInnerHTML={{ __html: content }} />
                        </div>
                    </div>
                </div>
                <div className="messengerCt__message-pic">
                    <img src={userAvatar} alt="" />
                </div>
            </div>
        </div>
    );
};

export default UserMessage;